import { addDisplayName, flowMax } from 'ad-hok'
import { addEffectOnMount } from 'ad-hok-utils'
import { FC } from 'react'
import { addNavigate } from 'shared/src/utils/addNavigate'
import { addAuthContext } from 'shared/src/utils/auth'

export const LogOut: FC = flowMax(
  addDisplayName('LogOut'),
  addNavigate,
  addAuthContext,
  addEffectOnMount(({ navigate, invalidateCredentials }) => () => {
    invalidateCredentials()
    navigate('/')
  }),
  () => null
)
